import './Abonneren.scss';

import { useEffect } from 'react';

import { Helmet } from 'react-helmet';
import breedbandLogo from '../../assets/icons/Breedband.svg';
import budgetLogo from '../../assets/icons/Budget.svg';
import caiwayLogo from '../../assets/icons/Caiway.svg';
import canaldigitalLogo from '../../assets/icons/Canaldigital.svg';
import deltaLogo from '../../assets/icons/DELTA.svg';
import fiberLogo from '../../assets/icons/Fiber.svg';
import kpnLogo from '../../assets/icons/KPN.svg';
import kabelnoordLogo from '../../assets/icons/Kabelnoord.svg';
import kabeltexLogo from '../../assets/icons/Kabeltex.svg';
import onlineLogo from '../../assets/icons/Online.svg';
import plinqLogo from '../../assets/icons/Plinq.svg';
import skpLogo from '../../assets/icons/SKP.svg';
import skvLogo from '../../assets/icons/SKV.svg';
import solconLogo from '../../assets/icons/Solcon.svg';
import stipteLogo from '../../assets/icons/Stipte.svg';
import trinedLogo from '../../assets/icons/Trined.svg';
import xs4allLogo from '../../assets/icons/XS4ALL.svg';
import youfoneLogo from '../../assets/icons/Youfone.svg';
import ziggoLogo from '../../assets/icons/Ziggo.svg';
import canalPlusLogo from '../../assets/icons/canalPlus.svg';
import odidoLogo from '../../assets/icons/odido.png';
import linkVisual from '../../assets/images/abonneren-top-2.jpg';
import topVisual from '../../assets/images/abonneren-top-3.webp';
import PageLayout from '../../layouts/PageLayout';
import { pageView } from '../../scripts/analytics';
import ExpandableGrid from './blocks/ExpandableGrid/ExpandableGrid';
import Header from './blocks/Header';

const providers = [
    {
        logo: kpnLogo,
        name: 'KPN',
        label: 'MijnKPN',
        link: '//mijn.kpn.com',
        secondaryLink: 'https://www.kpn.com/televisie/pakketten/espn.htm',
    },
    {
        logo: ziggoLogo,
        name: 'Ziggo',
        label: 'Mijn Ziggo',
        link: 'https://shop.ziggo.nl/inlifesales/aanbieding?campaign_code=espnnl&offer_skus=Z_T_34',
        secondaryLink:
            'https://www.ziggo.nl/televisie/extra-zenders-streamingdiensten/espn-compleet',
    },
    {
        logo: odidoLogo,
        name: 'Odido',
        label: 'Mijn Odido',
        link: 'https://www.odido.nl/login?fixedRedirectUrl=%2Fconnect%2Fauthorize%2Fcallback%3Fresponse_type%3Dcode%26client_id%3Dselfcare.client%26state%3DNmtwYVNMM3RocHBSUG9WU3BORFRnLnd0cmgzQ1BVMlhWUG11MWJFZ3RkQkhX;%25252F%26redirect_uri%3Dhttps%253A%252F%252Fthuismy.t-mobile.nl%252Fauth-callback%26scope%3Dopenid%2520selfcare.api%2520customer%26code_challenge%3DQUsRIoUxG_E_FQwiLTu7gZvUJ2lJkhCtsDWDwJENj9k%26code_challenge_method%3DS256%26nonce%3DNmtwYVNMM3RocHBSUG9WU3BORFRnLnd0cmgzQ1BVMlhWUG11MWJFZ3RkQkhX',
        secondaryLink: 'https://www.odido.nl/tv/zenderpakketten/espn',
    },

    {
        logo: deltaLogo,
        name: 'Delta',
        label: 'Delta',
        link: 'https://login.delta.nl/openam/XUI/#login/&realm=/zeelandnet&forward=true&spEntityID=urn%3Asp%3Amijndelta%3Aproductie&goto=%2FSSOPOST%2FmetaAlias%2Fzeelandnet%2Fidp1%3FReqID%3D_f40511ce-b57f-4d99-923a-8d2c5fb3a7e1%26index%3Dnull%26acsURL%3Dhttps%253A%252F%252Fmijn.delta.nl%252FSAML%252FSSO%252FPost%26spEntityID%3Durn%253Asp%253Amijndelta%253Aproductie%26binding%3Durn%253Aoasis%253Anames%253Atc%253ASAML%253A2.0%253Abindings%253AHTTP-POST&AMAuthCookie=',
        secondaryLink:
            'https://www.delta.nl/televisie/extra-zenders/espn-compleet/',
    },
    {
        logo: caiwayLogo,
        name: 'Caiway',
        label: 'Mijn Caiway',
        link: 'https://mijn.caiway.nl/general.logOn.logic',
        secondaryLink:
            'https://www.caiway.nl/televisie/zenderpakketten/espn-compleet',
    },
    {
        logo: canaldigitalLogo,
        name: 'Canal Digitaal',
        label: 'Mijn Canal Digitaal',
        link: 'https://www.canaldigitaal.nl/mijn-canaldigitaal/',
        secondaryLink: 'https://www.canaldigitaal.nl/extra-pakketten/espn/',
    },
    {
        logo: canalPlusLogo,
        name: 'CANAL+',
        label: 'Mijn CANAL+',
        link: 'https://www.canalplus.nl/mijnprofiel/',
        secondaryLink: 'https://www.canalplus.nl/sport/',
    },
    {
        logo: onlineLogo,
        name: 'Online',
        label: 'Mijn Online',
        link: 'https://www.online.nl/mijnonlinenl/login/',
        secondaryLink: 'https://www.online.nl/televisie/zenders/espn/',
    },
    {
        logo: breedbandLogo,
        name: 'Breedband Helmond',
        label: 'Mijn Breedband Helmond',
        link: 'https://mijnbbh.nl:1443/cw/main/logon.aspx',
        secondaryLink:
            'https://www.breedbandhelmond.nl/index.php/televisie/premium-zenders/espn-compleet',
    },
    {
        logo: budgetLogo,
        name: 'Budget',
        label: 'MijnBudget',
        link: 'https://mijn.budgetthuis.nl/',
        secondaryLink: 'https://www.budgetthuis.nl/alles-in-1/tv/espn',
    },
    {
        logo: kabelnoordLogo,
        name: 'Kabelnoord',
        label: 'Kabelnoord',
        link: 'https://www.kabelnoord.nl/service-en-contact/klantenservice/abonnement-wijzigen',
        secondaryLink:
            'https://www.kabelnoord.nl/aanbod/televisie/extra-zenderpakketten/espn',
    },
    {
        logo: kabeltexLogo,
        name: 'Kabeltex',
        secondaryLink: 'https://noordkop.kabeltex.nl/',
    },
    {
        logo: plinqLogo,
        name: 'Plinq',
        secondaryLink: 'https://www.plinq.nl/espn/',
    },
    {
        logo: skpLogo,
        name: 'SKP',
        label: 'SKP',
        link: 'https://mijnskp.skpnet.nl/',
        secondaryLink: 'https://skpnet.nl/tv/',
    },
    {
        logo: skvLogo,
        name: 'SKV',
        label: 'Mijn SKV',
        link: 'https://www.skv.nl/mijn-skv/',
        secondaryLink: 'https://www.skv.nl/zenders/#extra-zenders',
    },
    {
        logo: solconLogo,
        name: 'Solcon',
        label: 'Solcon',
        link: 'https://authenticate.solcon.nl/login',
        secondaryLink:
            'https://www.solcon.nl/particulier/televisie/extra-zenderpakketten/espn/',
    },
    {
        logo: stipteLogo,
        name: 'Stipte',
        label: 'Stipte',
        link: 'https://mijn.stipte.nl/selfcare/selfcare/',
        secondaryLink: 'https://www.stipte.nl/zenderoverzicht/#fox/',
    },
    {
        logo: trinedLogo,
        name: 'Trined',
        label: 'Mijn Trined',
        link: 'https://trikx.nl/mijntrined/',
        secondaryLink: 'https://www.trined.nl/diensten/televisie/zenders/',
    },
    {
        logo: xs4allLogo,
        name: 'XS4ALL',
        label: 'Mijn XS4ALL',
        link: 'https://inloggen.xs4all.nl/login',
        secondaryLink: 'https://www.xs4all.nl/televisie/',
    },
    {
        logo: youfoneLogo,
        name: 'Youfone',
        label: 'MyYoufone',
        link: 'https://my.youfone.nl/login',
        secondaryLink:
            'https://www.youfone.nl/thuis/tv/pakketten/sportpakketten/espn',
    },
    {
        logo: fiberLogo,
        name: 'Fiber',
        secondaryLink: 'https://fiber.nl/',
    },
];

const Abonneren = () => {
    useEffect(() => {
        pageView('abonneren');
    }, []);

    const logoClickEvent = providerName => {
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || [];

        // Push to the data layer
        window.dataLayer.push({
            event: 'providerLogoClick',
            providerName: providerName,
        });

        window.gtag('event', 'conversion', {
            allow_custom_scripts: true,
            u1: 'ESPN Campagne Abonneren',
            u98: providerName,
            send_to: 'DC-9800068/espn-c/nl_es0+standard',
        });

        gtag_report_conversion();
    };

    const gtag_report_conversion = url => {
        var callback = function () {
            if (typeof url != 'undefined') {
                window.location = url;
            }
        };
        window.gtag('event', 'conversion', {
            send_to: 'AW-329376570/FaU5CMeB89AYELrGh50B',
            event_callback: callback,
        });
        return false;
    };

    return (
        <PageLayout theme="dark">
            <Helmet>
                <title>ESPN - Kijk alle Eredivisie wedstrijden live!</title>
                <meta
                    name="description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live. Abonneer nu!"
                />
                <meta
                    property="og:title"
                    content="ESPN - Kijk alle Eredivisie wedstrijden live!"
                />
                <meta
                    property="og:description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live. Abonneer nu!"
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:image"
                    content={`${window.location.protocol}//${window.location.hostname}${linkVisual}`}
                />
                {/* <!-- Google Tag Manager --> */}
                <script>
                    {(function (w, d, s, l, i) {
                        w[l] = w[l] || [];
                        w[l].push({
                            'gtm.start': new Date().getTime(),
                            event: 'gtm.js',
                        });
                        var f = d.getElementsByTagName(s)[0],
                            j = d.createElement(s),
                            dl = l !== 'dataLayer' ? '&l=' + l : '';
                        j.async = true;
                        j.src =
                            'https://www.googletagmanager.com/gtm.js?id=' +
                            i +
                            dl;
                        f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', 'GTM-PQ7TFLN')}
                </script>
                {/* <!-- End Google Tag Manager --> */}
            </Helmet>
            <Header
                image={topVisual}
                title={
                    <>
                        Mis niks met
                        <br />
                        ESPN Compleet
                    </>
                }
            />

            <ExpandableGrid
                id="providers"
                tiles={providers}
                theme="dark"
                logoClickEvent={logoClickEvent}
            />
        </PageLayout>
    );
};

export default Abonneren;
